/* eslint-disable */
(function spd($, Drupal) {
  // Drupal.behaviors.spd = {
  //   attach(context) {

      if ($('.species-directory-v2').length) {

        // // Direct query attempt.
        // $('#edit-oq').val($('#edit-oq').val().replaceAll('\"', ''));

        // // Update query on submit to add double quotes
        // $('form').submit(function(e) {
          
        //   if ($('#edit-oq').val() !== '') {
        //     let oldval = '\"' + $('#edit-oq').val() + '\"';
        //     $('#edit-oq').once().val(oldval);
        //   }
         
        // });

        // $('#edit-oq').focus(function() {
        //   $(this).val($(this).val().replaceAll('\"', ''));
        // });
        // // End Direct query attempt.

        $('#edit-items-per-page option:last').show();
        
        // Get table sort values.
        let labelText = $('#view-title-table-column a').text();
        let linkValue = $('#view-title-table-column a').attr('href');

        // Lets make the up and down links.
        let acsLink = linkValue.replace('desc', 'asc');
        let descLink = linkValue.replace('asc', 'desc');
        $('#edit-items-per-page option:last').hide(); 

        // Arrow Markup
        if (linkValue.includes("&sort=asc")) {
           $sortArrowMarkup = labelText + '<span class="sort-arrows"><span data-link="'+ acsLink +'" class="sort-arrow sort-arrows--up" aria-label="Asc">▲</span></span>';
        } else {
           $sortArrowMarkup = labelText + '<span class="sort-arrows"><span data-link="'+ descLink +'" class="sort-arrow sort-arrows--down" aria-label="Desc">▼</span></span>';
        }

        // Arrow Markup
        // $sortArrowMarkup = labelText + '<span class="sort-arrows"><span data-link="'+ acsLink +'" class="sort-arrow sort-arrows--up" aria-label="Asc">▲</span><span data-link="'+ descLink +'" class="sort-arrow sort-arrows--down" aria-label="Desc">▼</span></span>';

        // Rebuild and append.
        $('#view-title-table-column').html($sortArrowMarkup);

        // Click Listen
        $('.sort-arrows').on('click', '.sort-arrow', function() {
          window.location.href = $(this).attr('data-link');
        });

        // Auto submit pager
        $('#edit-items-per-page').change(function(){
          $('#sd-btn-submit').click();      
        });

        // Default SP Illustration
        $('.paragraph--view-mode--search-preview-image').each(function () {
          if ($(this).find('.field--name-field-dam-media').length == 0) {
            $(this).next().show();
          }
        });

        function isEmpty( el ){
          return !$.trim(el.html())
        }

        // Show null line if profile has no status.
        $('tbody .views-field-field-species-status-details').find('.paragraph--type--species-status-details').each(function () {
          if (isEmpty($(this))) {
            $(this).closest('li').remove();
          }
        });

        // ESA Tab Only
        if ($('.tab-esa').length || $('.tab-mm').length) {
          // Go through list and then remove non-esa
          $('.paragraph--type--species-status-details').each(function() {
            let text = $(this).find('.field--name-field-species-details-status').find('.field--item').text();
            // ESA Experimental Population
            if ($('.tab-esa').length) {

              let removeList = [
                'ESA Delisted',
                'ESA Proposed for Delisting',
                'ESA Under Review for Delisting',
                'ESA Petitioned'
              ];

              if (!text.startsWith('ESA') || jQuery.inArray(text, removeList) !== -1) {
                $(this).parent().remove();
              }
            }

            // Change status text.
            let statusText = $(this).find('.field--name-field-species-details-dps .field--item').text();
            if (statusText == 'Throughout Its Range' || statusText == 'Throughout its Range' || statusText == 'Throughout the Wider Caribbean Region') {
              $(this).find('.field--name-field-species-details-dps .field--item').text('Species');
            }
          });

          // Update ESA Table Header
          $('#view-field-species-status-details-table-column').html(`
          <div class="sp-sub-col sp-col-head">Listed Entity</div>
          <div class="sp-sub-col sp-col-head">Protected Status</div>
          <div class="sp-sub-col sp-col-head sp-year">Year Listed</div>
          <div class="sp-sub-col sp-col-head sp-rp">Recovery Plan</div>
          <div class="sp-sub-col sp-col-head sp-ch">Critical Habitat</div>
          <div class="sp-sub-col sp-col-head">Region</div>
          `);
        } else {
          
          // Species status formatting.
          $('tbody .views-field-field-species-status-details').find('ul').each(function () {
            if (isEmpty($(this))) {
              $(this).html('<li>---</li>');
            }

            var uniqueStatus = [];
            $(this).find('li').each(function(i, elem) {
              let txt = $(elem).text();
              uniqueStatus.push($.trim(txt.replace(/[\t\n]+/g,' ')));
            });

            // Remove duplciates.
            var seen = {};
            $(this).find('li').each(function(i, elem) {
              var txt = $(this).text();
              if (seen[txt])
                  $(this).remove();
              else
                  seen[txt] = true;
            });

            // Finally remove any empty vals.
            if ($(this).text().trim().length == 0) {
              $(this).html('<li>---</li>');
            }

            // let newSort = jQuery.uniqueSort( uniqueStatus );
            // $(this).html(newSort.join("<li/>"));

          });

          // Adjust for Species DPS
          $('tbody .views-field-field-species-details-dps, tbody .views-field-field-species-details-year, tbody .views-field-field-species-details-recovery, tbody .views-field-field-species-details-critical').each(function() {

            // Get text value and break into array.
            let html = $(this).html();
            let oldText = $.trim(html.replace(/<!--(.*?)-->/ig, '')); // Remove dev markup
            let list = oldText.split(', ');
            let uniqueList = _.uniq(list) // Remove duplicates.

            // Loop through array and build list.
            let newHtml = ''; 
            $.each(uniqueList, function(i, obj) {

                // Replace name.
                let text = 'Species';
                if (obj == 'Throughout Its Range' || obj == 'Throughout its Range') {
                  text = 'Species';
                } else {
                  text = obj;
                }
                newHtml += '<li>' + text +'</li>';
            });

            // Replace DOM with new list
            $(this).html('<ul>' + newHtml + '</ul>');


          });
        }

        $('.cshs-term-group__term').each(function() {
          $(this).wrapInner('<span></span>');
        });

        function hide(varBar) {
          $('td').each(function() {
            if ($(this).find('.sp-sub-col').length) {
              $(this).find('.sp-sub-col').each(function() {
                let text = $(this).text().replace(/ /g,'');
                if (text.includes('---')) {
                  if (varBar == 'yes') {
                    $(this).hide();
                  } else {
                    $(this).show();
                  }
                }
              });
            } else {
              let text = $(this).text().replace(/ /g,'');
              if (text.includes('---')) {
                if (varBar == 'yes') {
                  $(this).hide();
                } else {
                  $(this).show();
                }
              }
            }

            $(this).find('.mobile-lable').not(':first').remove();
          });

        }

        if ($(window).width() <= 800) {
            hide('yes');
        };
   
         $(window).on('resize', function() {
          if ($(this).width() <= 800) {
            hide('yes');
          } else {
            hide();
          }
        });

      }
  //   },
  // };
}(jQuery, Drupal));
/*eslint-enable */
